import Marquee from "react-fast-marquee";
import { Award, ShieldCheck, BadgeCheck, Medal } from "lucide-react";
import { AWARDS, PARTNERS } from "@/lib/data";

const iconMap = { Award, ShieldCheck, BadgeCheck, Medal };

export default function AwardsPartners() {
    return (
        <section data-testid="awards-partners" className="bg-bone border-t border-line">
            {/* Awards */}
            <div className="container-wide py-16 md:py-20">
                <div className="text-center mb-10">
                    <div className="overline">Accreditations</div>
                    <h3 className="mt-3 font-display text-2xl md:text-3xl font-light">
                        Licensed, insured &amp; accredited.
                    </h3>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                    {AWARDS.map((a) => {
                        const Icon = iconMap[a.icon] || Award;
                        return (
                            <div
                                key={a.label}
                                data-testid={`award-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="group flex flex-col items-center justify-center p-6 md:p-8 border border-line bg-bone2/50 hover:bg-bone2 transition-colors"
                            >
                                <Icon size={36} strokeWidth={1.25} className="text-clay mb-4 transition-transform group-hover:scale-110" />
                                <div className="text-sm md:text-base text-center font-medium text-ink">
                                    {a.label}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Partners marquee */}
            <div className="border-t border-line py-10 md:py-14 bg-bone2/50">
                <div className="text-center mb-8">
                    <div className="overline">Trusted partners &amp; suppliers</div>
                </div>
                <Marquee gradient gradientColor={"#F2EFE9"} speed={40} pauseOnHover>
                    {PARTNERS.map((p) => (
                        <div
                            key={p}
                            data-testid={`partner-${p.toLowerCase().replace(/\s+/g, "-")}`}
                            className="mx-8 md:mx-12 px-8 py-4 font-display text-lg md:text-xl text-ink/40 hover:text-clay tracking-wide border-x border-line partner-logo"
                        >
                            {p}
                        </div>
                    ))}
                </Marquee>
            </div>
        </section>
    );
}
